export default __webpack_public_path__ + "static/pattern2-86a8b1815bbad805d1b4b21fded00739.svg";